module.exports = __webpack_public_path__ + "static/img/小鹏XNGP系统.494c8ed4.png";